export default {
    // raas
    '/grant': {
        name: '资源授权',
        icon: 'iconfont iconshouquan'
    },
    '/manage': {
        name: '授权管理',
        icon: 'iconfont iconshouquan'
    },
    '/resources': {
        name: '资源管理',
        icon: 'iconfont iconziyuanguanli'
    },
    // 商户端
    '/provincialLevelData': {
        name: '数据看板',
        icon: 'iconfont iconshujutongji'
    },
    '/content/dataScreen': {
        name: '数据大屏私有化',
        icon: 'iconfont icongaikuangzonglan'
    },
    '/content/dataReport/reportList': {
        name: '数据看板',
        icon: 'iconfont icongaikuangzonglan'
    },
    '/shome/index': {
        name: '概况总览',
        icon: 'iconfont icongaikuangzonglan'
    },
    '/shome/newHome': {
        name: '数据概况',
        icon: 'iconfont icongaikuangzonglan'
    },
    '/jmData': {
        name: '军民概况总览',
        icon: 'iconfont icongaikuangzonglan'
    },
    '/qzjmData': {
        name: '军民概况总览',
        icon: 'iconfont icongaikuangzonglan'
    },
    '/demo_homepage': {
        name: '自主实施数据概览',
        icon: 'iconfont iconshujutongji'
    },
    '/resources/list': {
        name: '素材中心',
        icon: 'iconfont iconsucai2x'
    },
    '/course': {
        name: '课程管理',
        icon: 'iconfont iconkecheng2x'
    },
    '/question': {
        name: '考试管理',
        icon: 'iconfont iconkaoshi'
    },
    '/task': {
        name: '培训管理',
        icon: 'iconfont iconpeixunguanli'
    },
    '/certificate': {
        name: '助学工具',
        icon: 'iconfont iconzhuxuegongju'
    },
    '/ai': {
        name: '人才智能',
        icon: 'iconfont iconrencaizhineng'
    },
    '/commodity': {
        name: '商品管理',
        icon: 'iconfont iconshangpinguanli'
    },
    '/student': {
        name: '用户管理',
        icon: 'iconfont iconxueyuanguanli2x'
    },
    '/dataCenter': {
        name: '数据中心',
        icon: 'iconfont iconshangpinshujufenxi'
    },
    '/exchange': {
        name: '交易管理',
        icon: 'iconfont iconjiaoyiguanli'
    },
    '/content': {
        name: '内容管理',
        icon: 'iconfont iconneirongguanli'
    },
    '/': {
        name: '站点管理',
        icon: 'iconfont iconzhandianguanli'
    },
    '/solution': {
        name: '站点管理',
        icon: 'iconfont iconzhandianguanli'
    },
    '/run?id=129&name=自主实施体验租户': {
        name: '自主实施站点管理',
        icon: 'iconfont iconzhandianguanli'
    },
    '/organize': {
        name: '组织架构',
        icon: 'iconfont iconzuzhijiagou2x'
    },
    '/market': {
        name: '伟东商城',
        icon: 'iconfont iconweidongshangcheng'
    },
    '/finance': {
        name: '财务管理',
        icon: 'iconfont iconcaiwu1'
    },
    '/customer': {
        name: '客户管理',
        icon: 'iconfont iconkehuguanli2x'
    },
    '/basicInfo': {
        name: '基础信息',
        icon: 'iconfont iconjichuxinxi'
    },
    '/jmStudent': {
        name: '军民学员管理',
        icon: 'iconfont iconjunminxueyuanguanli'
    },
    '/messageSafe': {
        name: '信息安全',
        icon: 'iconfont iconxinxianquan'
    },
    '/trainingInstitution': {
        name: '机构入驻',
        icon: 'iconfont iconruzhushenhe'
    },
    '/rs_institutions': {
        name: '机构入驻',
        icon: 'iconfont iconruzhushenhe'
    },
    '/tenant_roles': {
        name: '角色管理',
        icon: 'iconfont iconjiaose'
    },
    '/institutional_roles': {
        name: '角色管理',
        icon: 'iconfont iconjiaose'
    },
    '/tenant_administrator': {
        name: '管理员管理',
        icon: 'iconfont iconchaojiguanliyuan'
    },
    '/institutional_administrator': {
        name: '管理员管理',
        icon: 'iconfont iconchaojiguanliyuan'
    },
    // 轻工联
    '/qing/audit': {
        name: '机构入驻',
        icon: 'iconfont iconruzhushenhe'
    },
    '/rs_institutionInfo': {
        name: '信息管理',
        icon: 'iconfont iconrecruitmentManage'
    },
    // 渠道方企业信息
    '/enterpriseInfo': {
        name: '渠道方企业信息',
        icon: 'iconfont iconrecruitmentManage'
    },
    '/offlineTraining': {
        name: '线下实训',
        icon: 'iconfont iconxunlianying2x'
    },
    '/auditManage': {
        name: '审核管理',
        icon: 'iconfont iconbaoming'
    },
    // mass
    //数字化人才管理平台
    '/model': {
        name: '模型管理',
        icon: 'iconfont iconmoxingguanli'
    },
    '/dashboard/overview': {
        name: '数据概览',
        icon: 'iconfont iconshujugailan'
    },
    '/dashboard/investor': {
        name: '数据概览',
        icon: 'iconfont iconshujugailan'
    },
    '/dashboard/platform': {
        name: '平台数据',
        icon: 'iconfont iconshujutongji'
    },
    //custom
    '/registrationManagement': {
        name: '报名管理',
        icon: 'iconfont iconbaoming'
    },
    '/school/cooperation': {
        name: '校企合作',
        icon: 'iconfont iconxiaoyuanqiye'
    },
    // management 企业招聘后台
    //招聘管理
    '/managementAdmin': {
        name: '招聘管理Admin',
        icon: 'iconfont iconrecruitmentManage'
    },
    '/setting': {
        name: '基本设置',
        icon: 'iconfont iconjibenshezhi'
    },
    '/changePwd': {
        name: '账号设置',
        icon: 'iconfont iconjibenshezhi'
    },
    '/advertise/positionIssueList': {
        name: '招聘管理',
        icon: 'iconfont iconrecruitmentManage'
    },
    '/inviteJob': {
        name: '招聘管理',
        icon: 'iconfont iconrecruitmentManage'
    },
    // marketingCenter 营销中心
    '/agentmanage': {
        name: '营销中心',
        icon: 'iconfont iconyingxiaozhongxin'
    },
    //评价管理
    '/evaluationManager': {
        name: '评价管理',
        icon: 'iconfont iconpingjiaguanli'
    },
    // 非侧边栏
    '/content/classify': {
        name: '分类管理',
    },
    '/content/articles': {
        name: '文章管理',
    },
    '/content/articles/add': {
        name: '编辑文章',
    },
    '/content/dissertation': {
        name: '专题管理'
    },
    '/content/dissertation/add': {
        name: '添加专题'
    },
    '/content/dissertation/editor': {
        name: '编辑专题'
    },
    '/content/dissertation/preview': {
        name: '预览'
    },
    '/jiazheng': {
        name: '使用帮助',
        icon: 'iconfont iconhelp'
    },
    '/basicInfo/roleList': {
        name: '角色',
        icon: 'iconfont'
    },
    '/basicInfo/userList': {
        name: '用户',
        icon: 'iconfont'
    },
    '/basicInfo/permissionList': {
        name: '权限',
        icon: 'iconfont'
    },
    '/basicInfo/permissionList/permissionManage': {
        name: '设置',
        icon: 'iconfont'
    },
    '/accounts': {
        name: '账号管理',
        icon: 'iconfont iconzhanghaoguanli'
    },
    '/service': {
        name: '智能客服',
        icon: 'iconfont iconkefu'
    },

    '/certificate/list': {
        name: '证书管理',
        icon: 'iconfont iconzhengshuicon'
    },
    '/certificate/edit': {
        name: '证书管理',
        icon: 'iconfont'
    },
    '/classification': {
        name: '资源分类',
        icon: 'el-icon-s-goods'
    },
    '/customer/client': {
        name: '客户',
        icon: 'iconfont'
    },
    '/course/list': {
        name: '点播课程',
        icon: 'iconfont'
    },
    '/course/list/news': {
        name: '',
        icon: 'iconfont'
    },
    '/course/list/platformlist': {
        name: '平台课程',
        icon: 'iconfont'
    },
    '/course/list/preview': {
        name: '课程预览',
        icon: 'iconfont'
    },
    '/coursecenter': {
        name: '课程管理',
        icon: 'iconfont iconkecheng2x'
    },
    '/coursecenter/list/add': {
        name: '',
        icon: 'iconfont'
    },
    '/coursecenter/list/preview': {
        name: '课程预览',
        icon: 'iconfont'
    },
    '/question/exam': {
        name: '考试模块',
        icon: 'iconfont iconkaoshi'
    },
    '/question/exam/news': {
        name: 'exam',
        icon: 'iconfont'
    },
    '/question/exam/statistics': {
        name: '统计分析',
        icon: 'iconfont'
    },
    '/question/exam/ranks': {
        name: '统计分析',
        icon: 'iconfont'
    },
    '/question/exam/view/details"': {
        name: '统计分析',
        icon: 'iconfont'
    },
    '/question/exam/details': {
        name: '查看考试',
        icon: 'iconfont'
    },
    '/question/list': {
        name: '素材',
        icon: 'iconfont'
    },
    '/shome': {
        name: '数据中心',
        icon: 'iconfont iconshujukanban'
    },
    '/shome/courseScoreList': {
        name: '课程评分',
        icon: 'iconfont'
    },
    '/live': {
        name: '直播管理',
        icon: 'iconfont iconzhibo'
    },
    '/live/liveList': {
        name: '直播列表',
        icon: 'iconfont'
    },
    '/live/teacherLive': {
        name: '老师直播',
        icon: 'iconfont'
    },
    '/live/inspect': {
        name: '监课',
        icon: 'iconfont'
    },
    '/live/createLive': {
        name: '创建直播',
        icon: 'iconfont'
    },
    '/manage/course': {
        name: '课程',
        icon: 'iconfont'
    },
    '/manage/course/preview': {
        name: '课程预览',
        icon: 'iconfont'
    },
    '/market/list': {
        name: '素材库',
        icon: 'iconfont'
    },
    '/organize/index': {
        name: '分支机构管理',
        icon: 'iconfont'
    },
    '/organize/item': {
        name: '',
        icon: 'iconfont'
    },
    '/organize/department': {
        name: '部门管理',
        icon: 'iconfont'
    },
    '/answer': {
        name: '助教工具',
        icon: 'iconfont iconsucai2x'
    },
    '/answer/list': {
        name: '题库管理',
        icon: 'iconfont'
    },
    '/question/list': {
        name: '题库管理',
        icon: 'iconfont'
    },
    '/question/test/add': {
        name: '题库管理',
        icon: 'iconfont'
    },
    '/question/paper/add': {
        name: '题库管理',
        icon: 'iconfont'
    },
    '/resources/add': {
        name: '新建素材',
        icon: 'iconfont'
    },
    '/student/client': {
        name: '管理员',
        icon: 'iconfont'
    },
    '/student/list': {
        name: '学员管理',
        icon: 'iconfont'
    },
    '/student/info': {
        name: '查看学员',
        icon: 'iconfont'
    },
    '/student/impo': {
        name: '批量导入学员',
        icon: 'iconfont'
    },
    '/student/appoint': {
        name: '指派学员',
        icon: 'iconfont'
    },
    '/student/list/add': {
        name: '',
        icon: 'iconfont'
    },
    '/student/statistics': {
        name: '添加学员列表',
        icon: 'iconfont'
    },
    '/student/detail': {
        name: '详情',
        icon: 'iconfont'
    },
    '/talent': {
        name: '人才标准',
        icon: 'iconfont iconzuzhijiagou2x'
    },
    '/talent/index': {
        name: '岗位模型管理',
        icon: 'iconfont'
    },
    '/people/index': {
        name: '人才标准管理',
        icon: 'iconfont'
    },
    '/talent/detail': {
        name: '人才标准详情',
        icon: 'iconfont'
    },
    '/course/training': {
        name: '训练营',
        icon: 'iconfont iconxunlianying2x'
    },
    '/talent/training/news': {
        name: '',
        icon: 'iconfont'
    },
    '/talent/training/appoint': {
        name: '指派学员',
        icon: 'iconfont'
    },
    '/talent/training/add': {
        name: '添加学员',
        icon: 'iconfont'
    },
    '/talent/training/statistics': {
        name: '数据统计',
        icon: 'iconfont'
    },
    '/talent/training/detail': {
        name: '详情',
        icon: 'iconfont'
    },
    '/talent/training/certificate': {
        name: '配置证书',
        icon: 'iconfont'
    },
    '/message': {
        name: '消息管理',
        icon: 'iconfont iconxiaoxiguanli'
    },
    '/distribution': {
        name: '分销商品',
        icon: 'iconfont iconfenxiaoshangpin'
    },
    '/examPlans': {
        name: '考试计划管理',
        icon: 'iconfont iconkaoshi1'
    },
    '/examRooms': {
        name: '考点管理',
        icon: 'iconfont iconkaoshichangsuo'
    },
    '/distribution/listSort': {
        name: '分销商品管理',
        icon: 'iconfont iconfenxiaoshangpin'
    },
    '/settings': {
        name: '设置',
        icon: 'iconfont iconshezhi'
    },
    '/reportCertificate': {
        name: '报证管理',
        icon: 'iconfont iconbaozhengguanli'
    },
    '/interview': {
        name: '远程面试',
        icon: 'iconfont iconyuanchengmianshi'
    },
    '/applyManage': {
        name: '报名管理',
        icon: 'iconfont iconbaoming'
    },
    // 内容包管理
    '/package/list': {
        name: '内容包管理',
        icon: 'iconfont iconneirongbao'
    },
    // 师资管理
    '/teacher/list': {
        name: '师资管理',
        icon: 'iconfont iconyuanchengmianshi'
    },


    // 运营活动
    '/yunying': {
        name: '运营活动',
        icon: 'iconfont iconic-yunyinghuodongh'
    },
    // 机构会员
    '/member/organ-member-manage': {
        name: '机构会员',
        icon: 'iconfont iconic-zhuanyehuiyuanh'
    },
    // 人才应用
    '/appliedTalents': {
        name: '人才应用',
        icon: 'iconfont iconic-rencaiyingyongh'
    },
    // 短视频管理
    '/shortVideoManage': {
        name: '短视频管理',
        icon: 'iconfont iconic-shipinguanlih1'
    },
    // 首页管理
    '/homeManagement': {
        name: '首页管理',
        icon: 'iconfont iconic-shouyeguanlih'
    },
    // 实物商品
    '/physicalGoods': {
        name: '实物商品',
        icon: 'iconfont iconic-shiwushangpinh'
    },
    //推广管理
    '/marketing': {
        name: '推广管理',
        icon: 'iconfont icona-fenxiangtuiguang'
    },
    // 用户改造
    '/platform/tenant': {
        name: '租户管理',
        icon: 'iconfont iconkehuguanli2x'
    },
    '/platform/account': {
        name: '账号管理',
        icon: 'iconfont iconzhanghaoguanli'
    },
    '/permissionManage': {
        name: '权限管理',
        icon: 'iconfont iconjichuxinxi'
    },
    '/rolesList': {
        name: '角色管理',
        icon: 'iconfont iconjiaose'
    },
    '/readmin': {
        name: '管理员管理',
        icon: 'iconfont iconchaojiguanliyuan'
    },
    '/tenant/user': {
        name: '用户管理',
        icon: 'iconfont iconjiaose'
    },
    '/tenant/organ': {
        name: '机构管理',
        icon: 'iconfont iconzuzhijiagou2x'
    },
    '/organ/depart': {
        name: '部门管理',
        icon: 'iconfont iconzuzhijiagou2x'
    },
    '/organ/teacher': {
        name: '教师管理',
        icon: 'iconfont iconjiaose'
    },
    '/organ/student': {
        name: '学员管理',
        icon: 'iconfont iconxueyuanguanli2x'
    },
    '/organ/agent': {
        name: '代理商管理',
        icon: 'iconfont iconjiaose'
    },
    //名师-标签管理
    '/tag/list': {
        name: '标签管理',
        icon: 'iconfont iconkecheng2x'
    },
    //名师-入驻方管理
    '/workManManage': {
        name: '入驻方管理',
        icon: 'iconfont iconruzhushenhe'
    },

    /****** 商联会 **********************************/
    // 企业信息
    '/enterpriseInformation': {
        name: '企业信息',
        icon: 'iconfont iconxiaoyuanqiye'
    },
    '/declare': {
        name: '技能评定申报',
        icon: 'iconfont iconbaoming'
    },
    '/housekeepingManagement/list': {
        name: '家政员管理',
        icon: 'iconfont iconic-rencaiyingyongh'
    },
    '/SkillAssessmentProgress': {
        name: '技能评定申报查询',
        icon: 'iconfont iconrecruitmentManage'
    },
    '/declarationPayManagement/list': {
        name: '申报任务管理',
        icon: 'iconfont iconneirongguanli'
    },
    '/housekeepingDeclarationForm': {
        name: '家政申请列表',
        icon: 'iconfont iconic-dingdanmingxih'
    },
    '/housekeepingList': {
        name: '家政员列表',
        icon: 'iconfont iconic-rencaiyingyongh'
    },
    '/skillLevelManagement/list': {
        name: '技能级别选项',
        icon: 'iconfont iconxinyongmoxing'
    },
    '/checkManagement': {
        name: '对账管理',
        icon: 'iconfont iconjiaoyiguanli'
    },
    '/companyAudit': {
        name: '家政公司审核',
        icon: 'iconfont iconbaoming'
    },
    '/trainingAgency': {
        name: '实操管理',
        icon: 'iconfont iconbaoxianguanli'
    },
    //
    '/evaluate-organization': {
        name: '评定首页',
        icon: 'iconfont iconshujugailan'
    },
    '/offlineTrainingManagement/list': {
        name: '实操管理',
        icon: 'iconfont iconshicaoguanli'
    },
    '/offlineTrainingHousekeepingList': {
        name: '家政员报名列表',
        icon: 'iconfont iconbaoming'
    },
    '/check-accreditation': {
        name: '制证首页',
        icon: 'iconfont iconshujugailan'
    },
    '/applyCertificateDeclareList': {
        name: '申请制证列表',
        icon: 'iconfont iconbaozhengguanli'
    },
    '/underline-shicao-list': {
        name: '实操监管',
        icon: 'iconfont iconjianguan'
    },
    '/examinerManagement/list': {
        name: '考评员管理',
        icon: 'iconfont iconxueyuanguanli2x'
    },
    //运营计划管理
    '/userGroupManagement': {
        name: '运营计划管理',
        icon: 'iconfont iconyingxiaozhongxin'
    },
    '/institution-input': {
        name: '入驻机构录入',
        icon: 'iconfont iconbaoming'
    },
    /****** 三年千县百亿 **********************************/
    '/threeYearDevelop': {
        name: '三年千县百亿',
        icon: 'iconfont iconyingxiaozhongxin'
    },
    /****** 治理系统 **********************************/
    '/home': {
        name: '首页',
        icon: 'iconfont iconic-shouyeguanlih'
    },
    '/system': {
        name: '系统治理',
        icon: 'iconfont iconbaoxianguanli'
    },
    '/system-view': {
        name: '系统治理',
        icon: 'iconfont iconbaoxianguanli'
    },
    '/govern-system-account': {
        name: '用户治理',
        icon: 'iconfont iconic-rencaiyingyongh'
    },
    '/platformThrough': {
        name: '平台打通',
        icon: 'iconfont iconyingxiaozhongxin'
    },
    '/run': {
        name: '站点管理',
        icon: 'iconfont iconzhandianguanli1'
    },


    /****** 非煤数据大屏 **********************************/
    '/feimei/provincialLevelData3': {
        name: '非煤省级数据看板',
        icon: 'iconfont icongaikuangzonglan'
    },
    '/feimei/downtown3': {
        name: '非煤市级数据看板',
        icon: 'iconfont icongaikuangzonglan'
    },

    '/feimei/district3': {
        name: '非煤区级数据看板',
        icon: 'iconfont icongaikuangzonglan'
    },

    '/feimei/towns3': {
        name: '非煤乡镇数据看板',
        icon: 'iconfont icongaikuangzonglan'
    },

    '/feimei/enterprise3': {
        name: '非煤企业数据看板',
        icon: 'iconfont icongaikuangzonglan'
    },

    '/feimei/student': {
        name: '非煤员工',
        icon: 'iconfont iconxueyuanguanli2x'
    },
    /******** 元氏县数据大屏 */

    '/ysx/district': {
        name: '元氏县级数据看板',
        icon: 'iconfont icongaikuangzonglan'
    },

    '/ysx/towns': {
        name: '元氏县乡镇数据看板',
        icon: 'iconfont icongaikuangzonglan'
    },

    '/ysx/enterprise': {
        name: '元氏县企业数据看板',
        icon: 'iconfont icongaikuangzonglan'
    },

    /******** 森林防火数据大屏 */
    '/senlinfanghuo/enterprise': {
        name: '森林防火企业数据看板',
        icon: 'iconfont icongaikuangzonglan'
    },
    '/senlinfanghuo/WholeIndustry/province': {
        name: '森林防火全行业省数据看板',
        icon: 'iconfont icongaikuangzonglan'
    },
    '/senlinfanghuo/WholeIndustry/city': {
        name: '森林防火全行业市数据看板',
        icon: 'iconfont icongaikuangzonglan'
    },
    '/senlinfanghuo/WholeIndustry/region': {
        name: '森林防火全行业区数据看板',
        icon: 'iconfont icongaikuangzonglan'
    },
    '/senlinfanghuo/WholeIndustry/street': {
        name: '森林防火全行业街道数据看板',
        icon: 'iconfont icongaikuangzonglan'
    },
    '/senlinfanghuo/industry/province': {
        name: '森林防火各行业省数据看板',
        icon: 'iconfont icongaikuangzonglan'
    },
    '/senlinfanghuo/industry/city': {
        name: '森林防火各行业市数据看板',
        icon: 'iconfont icongaikuangzonglan'
    },
    '/senlinfanghuo/industry/region': {
        name: '森林防火各行业区数据看板',
        icon: 'iconfont icongaikuangzonglan'
    },
    '/senlinfanghuo/industry/street': {
        name: '森林防火各行业街道数据看板',
        icon: 'iconfont icongaikuangzonglan'
    },
    '/senlinfanghuo/student': {
        name: '森林防火员工',
        icon: 'iconfont iconxueyuanguanli2x'
    },

    /*******   溪午青禾 ************/
    '/xwqh/task/list': {
        name: '培训任务',
        icon: 'iconfont iconpeixunguanli'
    },
    '/user/list': {
        name: '用户管理',
        icon: 'iconfont iconjiaose'
    },
    '/xwqh/InspirationManagement/list': {
        name: '灵感管理',
        icon: 'iconfont iconrecruitmentManage'
    },
    '/clue/list': {
        name: '线索管理',
        icon: 'iconfont iconbaoming'
    },
    /******** 市民云学堂推广数据大屏 */
    '/smyxt/city': {
        name: '北京市市民云学堂推广数据大屏',
        icon: 'iconfont icongaikuangzonglan'
    },
    '/smyxt/district': {
        name: '北京市市民云学堂推广数据大屏',
        icon: 'iconfont icongaikuangzonglan'
    },
    '/smyxt/street': {
        name: '北京市市民云学堂推广数据大屏',
        icon: 'iconfont icongaikuangzonglan'
    },
    '/smyxt/community': {
        name: '北京市市民云学堂推广数据大屏',
        icon: 'iconfont icongaikuangzonglan'
    },
}


